export default __webpack_public_path__ + "static/7_16-4da089ad859b60fc9db2d350c011dfa7.png";